/**
 * Map an audit event_type to its domain + an AntD Tag color.
 *
 * Event types are dotted (`user.deleted`, `workspace.allowed_domains_updated`);
 * the domain is the prefix. Colors group events by domain in the audit-trail
 * table. AntD preset color names resolve to the Ant palette the design system
 * embeds.
 */

const DOMAIN_COLORS = {
  user: "green",
  workspace: "cyan",
  provisioning: "orange",
  impersonation: "purple",
  invitation: "blue",
};

/** The domain prefix of an event type (`user.deleted` → `user`). */
export const eventDomain = (eventType) =>
  typeof eventType === "string" ? eventType.split(".")[0] : "";

/** AntD Tag color for an event type; `"default"` for an unknown domain. */
export const eventColor = (eventType) =>
  DOMAIN_COLORS[eventDomain(eventType)] || "default";
